module Meevo.Components.Controls.SmartMover {
  export interface IStrategyApiBase {
    url: string;
    criteria?: _.Dictionary<any>;
  }

  export abstract class StrategyApiBase<TRes> implements ICollectionPopulate {

    protected parent: ICollectionBase<any>;
    protected child: ICollectionBase<any>;
    protected dataService: Meevo.Components.BaseClasses.IDataService;
    protected options: IStrategyApiBase;
    protected result: TRes[];

    private canceller: ng.IDeferred<any> = null;

    constructor(
      parent: ICollectionBase<any>,
      child: ICollectionBase<any>,
      dataService: Meevo.Components.BaseClasses.IDataService,
      options: IStrategyApiBase
    ) {
      this.child = child;
      this.parent = parent;
      this.dataService = dataService;
      this.options = options;

      this.fetch();
    }

    protected fetch() {
      if (this.canceller) {
        this.canceller.resolve([]);
      }

      this.canceller = this.dataService.Promise.defer();

      return this.dataService
        .getListPaged(this.options.url, { criteria: this.options.criteria, itemsPerPage: 50000 }, null, null, {
          timeout: this.canceller.promise
        })
        .then((res: TRes[]) => {
          this.result = res;
          this.canceller.resolve();

          return this.result;
        });
    }

    abstract populateData(): void;

    populate() {
      if ((this.canceller.promise as any).$$state.status === 0) {
        this.canceller.promise.then(() => this.populateData());
      } else {
        this.populateData();
      }
    }
  }
}
